import React from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';

import PartialScrollContainer from "../../../../base/components/partial_scroll_container.js";

import MybilioTextLogoBronze from "../../../../resources/logo/mybilio_text_logo_bronze.js";

import rightBackground from "../resources/images/right_background.jpg";

const styles = theme => ({
  root: {
    height: "100vh",
    display: "flex"
  },
  leftSide: {
    height: "100%",
    flexGrow: "1",
    backgroundColor: theme.palette.white
  },
  rightSide: {
    backgroundImage: `url(${rightBackground})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    overflow: "hidden",
    flexBasis: "33%",
    flexShrink: "0",
    height: "100%",
    ['@media (max-width: 992px)']: {
      display: "none"
    }
  },
  content: {
    margin: "0px auto",
    maxWidth: "439px",
    padding: "80px 0px 40px",
    position: "relative",
    ['@media (max-width: 768px)']: {
      padding: "68px 24px 0"
    }
  },
  logo: {
    display: "block",
    width: "157px",
    height: "75px",
    marginBottom: "50px",
    ['@media (max-width: 768px)']: {
      width: "112px",
      height: "60px",
      marginBottom: "45px"
    }
  },
  title: {
    display: "block",
    minHeight: "32px",
    fontSize: "32px",
    lineHeight: "46px",
    textTransform: "uppercase",
    marginBottom: "35px",
    ['@media (max-width: 768px)']: {
      fontSize: "18px",
      lineHeight: "20px",
      marginBottom: "20px"
    }
  }
});

class BaseSessionPage extends React.Component {
  
  render() {
    const { classes, children, title } = this.props;
    return <div className = { classes.root } >
      <PartialScrollContainer className = { classes.leftSide } >
        <div className = { classes.content } >
          <MybilioTextLogoBronze className = { classes.logo } />
          { title && 
            <span className = { classes.title } >
              { title }
            </span>
          }
          { children }
        </div>
      </PartialScrollContainer>
      <div className = { classes.rightSide } />
    </div>
  }
}

BaseSessionPage.propTypes = {
  children: PropTypes.node
};

export default withStyles(
  (theme) => ({
    ...styles(theme),
  }),
  { withTheme: true },
)(BaseSessionPage);